import React from "react";

const SmallHeartIcon = () => {
  return (
    <svg
      width="13"
      height="11"
      viewBox="0 0 13 11"
      className="icon_reaction--25RS_"
    >
      <path
        fill="#444"
        d="M9.343.008C8.51.063 7.735.418 7.142 1.02l-.64.65-.643-.651C5.212.363 4.35 0 3.432 0S1.65.363 1.005 1.02c-1.34 1.358-1.34 3.566-.001 4.927l4.748 4.746c.358.36.921.408 1.335.121l.11-.089.034-.031 4.907-4.905c1.206-1.386 1.135-3.474-.14-4.769C11.352.363 10.488 0 9.571 0l-.228.008zm.228 1.038c.636 0 1.23.25 1.681.708l.128.14c.768.912.774 2.284-.007 3.182L6.49 9.953 1.747 5.21C.811 4.26.812 2.706 1.75 1.754c.45-.458 1.046-.708 1.682-.708.636 0 1.231.25 1.682.708l1.016 1.03c.205.207.54.207.745-.001l1.013-1.03c.45-.457 1.046-.707 1.683-.707z"
      ></path>
    </svg>
  );
};

export default SmallHeartIcon;
